import axios from "axios";

const useNotificationsProvider = () => {
  const listNotificationsProvider = ({page, search, state, type, init_date, end_date}) => {
    return axios ({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}api/app-notifications?page=${page}`,
      params: {search, state, type, init_date, end_date}
    })
  }

  const getNotificationProvider = (id) => {
    return axios ({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}api/app-notifications/${id}`,
    })
  }

  const getMembeerGroupsProvider = () => {
    return axios ({
      method: "get",
      url: `membeer_groups-list`,
    })
  }

  const getNotificationsEntitiesProvider = () => {
    return axios ({
      method: "get",
      url: `notifications/entities`,
    })
  }

  const getNotificationsEntitiesByIdProvider = (id) => {
    return axios ({
      method: "get",
      url: `global/entity/${id}`,
    })
  }

  const addNotificationProvider = (data) => {
    return axios ({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}api/app-notifications`,
      data
    })
  }

  const addRemindersProvider = (data) => {
    return axios ({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}core/v1/reminders-array`,
      data: {"reminders": [...data]}
    })
  }

  const cloneNotificationProvider = ({ id, project_id }) => {
    return axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}api/app-notifications/clone/${id}`,
      data: { is_duplicated: true, project_id },
    });
  };

  const editNotificationProvider = ({id, datos}) => {
    return axios({
      method: "put",
      url: `${process.env.REACT_APP_API_URL}api/app-notifications/${id}`,
      data: datos,
    });
  };

  const deleteNotificationProvider = (id) => {
    return axios({
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}api/app-notifications/${id}`,
    });
  };

  return {
    addNotificationProvider,
    addRemindersProvider,
    cloneNotificationProvider,
    deleteNotificationProvider,
    editNotificationProvider,
    getMembeerGroupsProvider,
    getNotificationProvider,
    listNotificationsProvider,
    getNotificationsEntitiesProvider,
    getNotificationsEntitiesByIdProvider
  }
}

export default useNotificationsProvider;